import { useEffect, useState } from "react";
import { TextMediumBase, TextMediumSM, TextMediumXS } from "../../../../Components/Text/MediumText";
import { TextXS } from "../../../../Components/Text/NormalText";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import { BackButton, EditButton } from "../../../../Components/Utils/Buttons";
import axiosInstance from "../../../../Services/axiosCommon";
import { Link } from "react-router-dom";
import { GetAccess } from "../../../../Components/Utils/roles";
import { Building2 } from "lucide-react";
import NuDate from "../../../../Components/Utils/NuDate";

const CompanyInfo = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);

  const GetData = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(`/company-info/1`);
      if (response?.data?.data) {
        setData(response.data.data);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    GetData();
  }, []);

  // if (loading) {
  //   return (
  //     <div className="w-full h-full px-4 py-2">
  //       <div className="flex justify-center items-center h-full">
  //         <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
  //       </div>
  //     </div>
  //   );
  // }

  return (
    <div className="w-full h-full px-4 py-2 bg-gray-50 overflow-hidden">
      {/* Header Section */}
      <div className="w-full sm:flex justify-between items-center mb-6">
        <Breadcrumb
          items={[
            { name: "Settings", link: "/settings" },
            { name: "Company Info" }
          ]}
        />
        <div className="flex justify-end gap-2 mt-2 sm:mt-0">
          <BackButton />
          {GetAccess('companyinfo_edit') && (
            <Link 
              to={"/settings/company/edit"} 
              state={{ data: data, from: "/settings" }}
              className="transition-transform hover:scale-105"
            >
              <EditButton color="black" height="8" />
            </Link>
          )}
        </div>
      </div>

      {/* Main Content */}
      <div className="w-full h-[calc(100vh-165px)]  mx-auto rounded-xl overflow-y-auto space-y-6">
        {/* Company Profile Card */}
        <div className="bg-white rounded-xl shadow-lg overflow-hidden">
          <div className="bg-gradient-to-r flex gap-2 from-red-600 to-red-400 p-2 text-white">
            <Building2 size={16} />
            <h2 className="text-sm font-semibold">Company Info</h2>
          </div>
          
          <div className="p-6 flex flex-col md:flex-row gap-8">
            {/* Logo Section */}
            <div className="w-full md:w-1/4 flex flex-col items-center">
              <div className="relative w-48 h-48 rounded-lg border-2 border-gray-200 flex items-center justify-center bg-gray-50 overflow-hidden">
                {data?.compLogo?.file ? (
                  <img
                    src={data.compLogo.file}
                    alt="Company Logo"
                    className="w-full h-full object-contain p-2"
                  />
                ) : (
                  <div className="text-gray-400 text-center p-4">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                    <p className="mt-2 text-sm">No Logo Available</p>
                  </div>
                )}
              </div>
              <p className="mt-4 p-2 bg-red-50 text-red-600 rounded-lg text-xs font-medium hover:bg-red-100 transition-colors">
               Company Profile
              </p>
            </div>

            {/* Company Details */}
            <div className="w-full md:w-3/4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <InfoCard 
                  icon="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  title="Basic Information"
                  items={[
                    { label: "Company", value: data?.companyName || "-" },
                    // { label: "Established On", value: data?.establishedOn || "-" },
                    { label: "Established On", value:  
                                          <NuDate
                                            value={data?.establishedOn}
                                            format="DD-MMM-YYYY"
                                          />
                    },

                    { label: "Industry", value: data?.businessIndustry || "-" },
                  ]}
                />

                <InfoCard 
                  icon="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  title="Contact Information"
                  items={[
                    { label: "Email", value: data?.email || "-" },
                    { label: "Mobile", value: data?.mobile?.display || "-" },
                    { label: "Website", value: data?.website || "-" },
                  ]}
                />

                <InfoCard 
                  icon="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                  title="Business Details"
                  items={[
                    { label: "Registration No.", value: data?.registrationNo || "-" },
                    { label: "Tax ID", value: data?.taxId || "-" },
                    { label: "Currency", value: data?.currency || "-" },
                    { label: "Thousand Separator", value: data?.currency_separator || "-" },
                    { label: "Date Format", value: data?.date_format || "-" },
                    // { label: "Time Zone", value: data?.timezone || "-" },


                  ]}
                />

                <InfoCard 
                  icon="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0zM15 11a3 3 0 11-6 0 3 3 0 016 0z"
                  title="Primary Address"
                  items={[
                    { label: "Street", value: data?.address?.streetName || "-" },
                    { label: "District", value: data?.address?.district || "-" },
                    { label: "City", value: data?.address?.city || "-" },
                    { label: "State/Province", value: data?.address?.state || "-" },
                    { label: "Country", value: data?.address?.country || "-" },
                    { label: "Zip/Postal Code", value: data?.address?.postalCode !== "None" ? data?.address?.postalCode : "-" },
                  ]}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Additional Address Sections */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 ">
          {/* Billing Address */}
          <div className="bg-white rounded-xl shadow-lg overflow-hidden mb-2">
            <div className="bg-gradient-to-r from-purple-600 to-purple-400 p-2 text-white">
              <h2 className="text-sm font-semibold flex items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                </svg>
                Billing Address
              </h2>
            </div>
            <div className="p-4">
              <div className="space-y-4">
                <InfoItem label="Address Line 1" value={data?.billingAddress1 || "-"} />
                <InfoItem label="Address Line 2" value={data?.billingAddress2 || "-"} />
                <div className="lg:grid grid-cols-2 gap-4">
                  <InfoItem label="City" value={data?.billing_city || "-"} />
                  <InfoItem label="State/Province" value={data?.billing_state || "-"} />
                </div>
                <div className="lg:grid grid-cols-2 gap-4">
                  <InfoItem label="Country" value={data?.billing_country || "-"} />
                  <InfoItem label="Zip/Postal Code" value={data?.billing_postal_code !== "None" ? data?.billing_postal_code : "-"} />
                </div>
              </div>
            </div>
          </div>

          {/* Delivery Address */}
          <div className="bg-white rounded-xl shadow-lg overflow-hidden mb-2">
            <div className="bg-gradient-to-r from-green-600 to-green-400 p-2 text-white">
              <h2 className="text-sm font-semibold flex items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path d="M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0" />
                </svg>
                Delivery Address
              </h2>
            </div>
            <div className="p-4">
              <div className="space-y-4">
                <InfoItem label="Address Line 1" value={data?.deliveryAddress1 || "-"} />
                <InfoItem label="Address Line 2" value={data?.deliveryAddress2 || "-"} />
                <div className="lg:grid grid-cols-2 gap-4">
                  <InfoItem label="City" value={data?.delivery_city || "-"} />
                  <InfoItem label="State/Province" value={data?.delivery_state || "-"} />
                </div>
                <div className="lg:grid grid-cols-2 gap-4">
                  <InfoItem label="Country" value={data?.delivery_country || "-"} />
                  <InfoItem label="Zip/Postal Code" value={data?.delivery_postal_code !== "None" ? data?.delivery_postal_code : "-"} />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Business Description */}
        {data?.businessDesc && (
          <div className="bg-white rounded-xl shadow-lg overflow-hidden mb-4">
            <div className="bg-gradient-to-r from-indigo-600 to-indigo-400 p-2 text-white">
              <h2 className="text-sm font-semibold flex items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z" />
                </svg>
                Business Description
              </h2>
            </div>
            <div className="p-4">
              <p className="text-gray-700 whitespace-pre-line">{data.businessDesc}</p>
            </div>
          </div>
        )} 
      </div>
    </div>
  );
};

// Reusable Info Card Component
const InfoCard = ({ icon, title, items }) => (
  <div className="rounded-lg p-2 border border-gray-200 hover:border-blue-300 transition-colors">
    <div className="flex items-center text-sm gap-2 mb-3">
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-baseColor-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={icon} />
      </svg>
      <h3 className="font-medium text-sm text-gray-800">{title}</h3>
    </div>
    <div className="space-y-2">
      {items.map((item, index) => (
        <InfoItem key={index} label={item.label} value={item.value} />
      ))}
    </div>
  </div>
);

// Reusable Info Item Component
const InfoItem = ({ label, value }) => (
  <div className="flex text-[13px]">
    <p className="font-medium text-gray-800 lg:w-28">{label}</p>
    <p className="font-medium text-gray-500 ">{" "} : {" "}{value}</p>
  </div>
);

export default CompanyInfo;